import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import TitlePage from '../../../common/TitlePage';
import { Box } from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
    root: {
        padding: "40px 0"
    },
    title: {
        textAlign: "center",
        '& p': {
            margin: "5px 0"
        }
    },
    color: {
        color: theme.palette.light.type2,
    },
    content: {
        ...theme.grid.gridLg,
        margin: "60px auto",
        display: "flex",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            margin: "50px auto",
            flexDirection: "column",
            alignItems: "center"
        }
    },
    item: {
        width: 235,
        height: 220,
        margin: "20px",
        boxSizing: "border-box",
        position: "relative",
        backgroundColor: "white",
        borderRadius: 15,
        boxShadow: "0 0 36px rgba(0, 0, 0, 0.161)",
        padding: 20,
        [theme.breakpoints.down("xs")]: {
            maxWidth: "98%",
            height: 167,
            margin: "23px auto",
        },
        '& span': {
            position: "absolute",
            top: 15,
            right: 15,
            color: "#DEDEDE",
            opacity: "55%",
            fontSize: 70,
            fontWeight: "bold"
        }
    },
    icon: {
        width: 70,
        height: 70,
        borderRadius: "50%",
        padding: 5,
        // border: `1px solid ${theme.palette.light.type2}`,
        border: `1px solid #0B1742;`,
        marginTop: 20,
        "& svg": {
            width: "100%",
            height: "100%",
        }
    },
    text: {
        fontSize: theme.fontSize.small,
        textAlign: 'center',
        [theme.breakpoints.down("xs")]: {
            width: '98%',
            // overflow: "hidden",
            // textOverflow: "ellipsis",
            // whiteSpace: "nowrap",
        },
    }
}))

export default function Index() {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <TitlePage position="bottomCenter" padding="0px 0px">
                <Box className={classes.title}>
                    <p className={classes.color}>3 گام</p>
                    <p> افتتاح حساب آسان و سریع</p>
                </Box>
            </TitlePage>

            <Box className={classes.content}>
                {
                    data.map((item, ind) => (
                        <a
                            // target="_blank"
                            href={item.link} key={ind} >
                            <div className={classes.item}>
                                <span>{item.number}</span>
                                <div className={classes.icon}>
                                    <svg>
                                        <use xlinkHref={`/sprit.svg#${item.icon}`}></use>
                                    </svg>
                                </div>

                                <p className={classes.text}>
                                    {item.text}
                                </p>
                            </div>
                        </a>
                    ))
                }
            </Box>
        </div>
    )
}


let data = [
    { text: "ثبت ‌نام و احراز هویت در سامانه سجام", icon: "autontication", link: "#", number: "۱" },
    { text: "ثبت‌ نام و احراز هویت غیرحضوری در کارگزاری پویان", icon: "open_account", link: "#", number: "۲" },
    { text: "صدور کد معاملات آنلاین  ", icon: "code_online", link: "#", number: "۳" }
]